export const shouldShowClipboardSelector = (state) => !state.system.clipboard.hasBeenDismissed && !!state.system.clipboard.contents;

export const clipboardContentsSelector = (state) => state.system.clipboard.contents;

export const isConnectedSelector = (state) => state.system.isConnected;

export const isInitCompleteSelector = (state) => state.system.isInitComplete;
